module.exports = __webpack_public_path__ + "img/moon-large.e4a17c84.png";